export const reporterFilterOptions = {
	data: {
		node: {
			getArchivedIssuesFilterOptions: {
				projectId: 'ari:cloud:jira:TEST--e16459ae-437f-4e97-8a64-3eec474df71b:project/10001',
				reporters: {
					edges: [
						{
							accountId: '7456224230842',
							name: 'a1',
							picture:
								'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png',
						},
						{
							accountId: '8456225230842',
							name: 'a2',
							picture:
								'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png',
						},
						{
							accountId: '2456224230840',
							name: 'a3',
							picture:
								'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png',
						},
						{
							accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
							picture:
								'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
							name: 'Rohit Kumar',
						},
					],
				},
			},
		},
	},
};
